import openBatchProcessesReducer from './open-batch-processes.reducer';
import setForceRenderReducer from './setForceRenderReducer';

export default {
  openBatchProcessesReducer,
  setForceRenderReducer,
};
